// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconHardwareDevicesLq_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 2H24V18H0V2ZM2 4H22V16H2V4Z" class="svg-bg"/>
  <path d="M16 20H8L7 22H17L16 20ZM10.5928 13.501H6.42285V6.49902H8V12.2217H10.5928V13.501ZM14.5312 13.6787C13.5286 13.6787 12.7116 13.3532 12.0801 12.7021 11.4486 12.0446 11.1328 11.1934 11.1328 10.1484 11.1328 9.04492 11.4535 8.14974 12.0947 7.46289 12.7327 6.7793 13.5824 6.4375 14.6436 6.4375 15.6429 6.4375 16.4502 6.76465 17.0654 7.41895 17.6839 8.06999 17.9932 8.93262 17.9932 10.0068 17.9932 11.1038 17.6725 11.9909 17.0312 12.668 17.0085 12.6908 16.9873 12.7135 16.9678 12.7363 16.9482 12.7559 16.9271 12.7754 16.9043 12.7949L18.6768 14.499H16.4697L15.542 13.5566C15.236 13.638 14.8991 13.6787 14.5312 13.6787ZM14.5996 7.79492C14.0495 7.79492 13.61 8.00326 13.2812 8.41992 12.9557 8.83333 12.793 9.38184 12.793 10.0654 12.793 10.7588 12.9557 11.3073 13.2812 11.7109 13.6068 12.1146 14.0332 12.3164 14.5605 12.3164 15.1042 12.3164 15.5355 12.1211 15.8545 11.7305 16.1735 11.3333 16.333 10.7881 16.333 10.0947 16.333 9.37207 16.1784 8.80729 15.8691 8.40039 15.5632 7.99674 15.14 7.79492 14.5996 7.79492Z" class="svg-bg"/>
</svg>
`;
/**
 * IconHardwareDevicesLq is a generated icon component.
 */
let IconHardwareDevicesLq = IconHardwareDevicesLq_1 = class IconHardwareDevicesLq extends IconBaseElement {
    render() {
        return html `${IconHardwareDevicesLq_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconHardwareDevicesLq.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconHardwareDevicesLq = IconHardwareDevicesLq_1 = __decorate([
    customElement('zui-icon-hardware-devices-lq')
], IconHardwareDevicesLq);
export { IconHardwareDevicesLq };
